import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AssistanceComponent,
  AuthenticationComponent,
  CallbackComponent,
} from '@features/index';
import { AuthenticationGuard } from '@core/index';
import { PageNotAuthorizedComponent } from '@features/errors/components/page-not-authorized/page-not-authorized.component';
import { PageNotFoundComponent } from '@features/errors/components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: 'authentication',
    component: AuthenticationComponent,
  },
  {
    path: 'assistance',
    component: AssistanceComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./features/home/home.module').then((module) => module.HomeModule),
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'home',
    redirectTo: '',
  },
  {
    path: 'import',
    loadChildren: () =>
      import('./features/import/import.module').then(
        (module) => module.ImportModule
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'monitoring',
    loadChildren: () =>
      import('./features/monitoring/monitoring.module').then(
        (module) => module.MonitoringModule
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'search',
    loadChildren: () =>
      import('./features/search/search.module').then(
        (module) => module.SearchModule
      ),
    canActivate: [AuthenticationGuard],
  },
  {
    path: 'error401',
    component: PageNotAuthorizedComponent,
  },
  {
    path: 'error404',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: 'error404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
